import { createElement, DetailedReactHTMLElement, InputHTMLAttributes } from 'react';
import * as Icons from '@mui/icons-material';
import { snakeToPascalCase } from './stringUtil';

export const createIconFromName = (
  name: string
): DetailedReactHTMLElement<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  createElement(Icons[snakeToPascalCase(name)] ?? Icons.Help);
